var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMailOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#68738D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m2.648 6.667 6.575 4.383a1.67 1.67 0 0 0 1.85 0l6.575-4.383M4.315 15.833h11.667a1.667 1.667 0 0 0 1.666-1.666V5.833a1.667 1.667 0 0 0-1.666-1.666H4.315a1.667 1.667 0 0 0-1.667 1.666v8.334a1.667 1.667 0 0 0 1.667 1.666"
})));
export { SvgMailOutline as ReactComponent };
export default __webpack_public_path__ + "6554af7b45446b9f0fb41cd25da1e6a7.svg";